import md5 from 'md5';

const ENTERPRISES_V20_URL = '/permissionManagment/permit/enterprises';
const ADD_ENTERPRISE_V20_URL = '/permissionManagment/permit/enterprise';
const UPDATE_ENTERPRISE_V20_URL = '/permissionManagment/permit/put_enterprise';
const DELETE_ENTERPRISE_V20_URL = '/permissionManagment/permit/delete_enterprise';
const ENTERPRISE_V3_URL = '/adminAuth/auth/v3/enterprise';
const ENTERPRISE_V4_URL = '/adminAuth/auth/v4/enterprise';
const ENTERPRISE_V5_URL = '/adminAuth/auth/v5/enterprise';

const IM_ENTERPRISE_URL = '/im-admin/create';

// 获取企业列表 - 超管用户
function getEnterprises() {
  return this.$reqGet(ENTERPRISES_V20_URL).then(rsp => rsp.data.result);
}

// 获取企业列表 - 管理员 & 普通用户
function getEnterpriseInfo(enterpriseId) {
  return this.$reqGet(`${ENTERPRISE_V3_URL}/${enterpriseId}`).then(rsp => rsp.data.result);
}

// 获取企业所勾选模块
function getEnterpriseModulesV3(id) {
  return this.$reqGet(`${ENTERPRISE_V3_URL}/${id}/modules`).then(rsp => rsp.data.result);
}

function getEnterpriseModules(id) {
  return this.$reqGet(`${ENTERPRISE_V4_URL}/${id}/modules`).then(rsp => rsp.data.result);
}

// 获取企业所勾产品
function getEnterpriseProductsV5(id) {
  return this.$reqGet(`${ENTERPRISE_V5_URL}/${id}/products`).then(rsp => rsp.data.result);
}

function addEnterprise(info, enableIM) {
  console.log(enableIM);
  // basic check of input parameter
  if (!info.name || !info.modules || !info.admin) {
    return new Promise((_, reject) => {
      reject('Invalid parameter');
    });
  }
  // const data = JSON.parse(JSON.stringify(info));
  // data.modules = JSON.stringify(info.modules);
  // data.products = JSON.stringify(info.products);
  info.admin.password = md5(info.admin.password);
  // data.admin = JSON.stringify(data.admin);

  return this.$reqPost(ADD_ENTERPRISE_V20_URL, info)
    .then((rsp) => {
      const enterprise = rsp.data.result;
      // const admin = enterprise.admins.length > 0 ? enterprise.admins[0] : {};
      if (enableIM) {
        return this.$reqPost(IM_ENTERPRISE_URL, {
          username: info.admin.account,
          ent_code: enterprise.id,
          display_name: info.admin.account,
          user_type: 1,
        });
      }
      return new Promise((resolve) => {
        resolve(rsp.data);
      });
    });
}

// 更新企业
function updateEnterprise(id, data) {
  const params = {
    ...data,
  };
  // params.modules = JSON.stringify(data.modules);
  return this.$reqPost(`${UPDATE_ENTERPRISE_V20_URL}/${id}`, params);
}

// 删除企业
function deleteEnterprise(id, reason) {
  return this.$reqPost(`${DELETE_ENTERPRISE_V20_URL}/${id}?reason=${reason}`);
  // let result;
  // return this.$reqPost(`${DELETE_ENTERPRISE_V20_URL}/${id}?reason=${reason}`)
  // .then(rsp => rsp.data.result);
}

export default {
  getEnterpriseInfo,
  getEnterprises,
  getEnterpriseModules,
  addEnterprise,
  updateEnterprise,
  deleteEnterprise,
  getEnterpriseModulesV3,
  getEnterpriseProductsV5,
};



// WEBPACK FOOTER //
// ./src/manage-modules/SystemManage/_api/enterprise.js